var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerBi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.1 38.7",
    style: {
      enableBackground: "new 0 0 29.1 38.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,4.9h-7.7c-0.7,0-1.2,0.5-1.2,1.2v5.3h2.9c1,0,1.9,0.9,1.9,1.9v20.5h4c0.7,0,1.2-0.5,1.2-1.2V6.1 C25.5,5.5,25,4.9,24.3,4.9C24.3,4.9,24.3,4.9,24.3,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,12.1h-7.7c-0.7,0-1.2,0.5-1.2,1.2v5.4h3.1c1,0,1.9,0.9,1.9,1.9v13.3h5.1V13.3 C19.6,12.6,19,12.1,18.4,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.9,19.4c-0.7,0-1.2,0.5-1.2,1.2v12.1c0,0.7,0.5,1.2,1.2,1.2h8.9V20.6c0-0.7-0.5-1.2-1.2-1.2H4.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerBi);
export default __webpack_public_path__ + "static/media/power-bi.c2dfcfb14105bc59026e502214ceed22.svg";
export { ForwardRef as ReactComponent };